import { render, staticRenderFns } from "./ModalTour.vue?vue&type=template&id=1f302a9c&"
import script from "./ModalTour.vue?vue&type=script&lang=js&"
export * from "./ModalTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports